import React, { useContext } from 'react'
import Particles from 'react-particles-js'
import styled from 'styled-components'
import { AppDevelopmentSkill, WebDevelopementSkill, DesignSkill } from '../AllSvg'
import { MyLogo } from '../components/MyLogo'
import { MobileSkillList } from '../data/MobileSkillList'
import { WebSkillList } from '../data/WebSkillList'
import ParticlessDarkBg from '../config/particlesjs-config-dark.json'
import ParticlessLightBg from '../config/particlesjs-config-light.json'
import { DesignSkillList } from '../data/DesignSkillList'
import { TabletSize } from '../responsive/TabletSize'
import { ThemeContext } from 'styled-components'

const Wrapper = styled.div`
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  scrollbar-width: none; 
  &::-webkit-scrollbar {
    display: none;
  }
`;  

const Container = styled.div`
  z-index: 1;
  height: fit-content;
  width: 100vw;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  ${TabletSize({ 
    flexDirection: "column",
    top: "15%",
    bottom: 0, 
    left: 0, 
    right: 0, 
    transform: "translate(0,0)",
  })};
`;

const Text = styled.h2`
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translate(-50%,-50%);
  opacity: 0.3;
  font-size: 40px;
`;

const SkillBox = styled.div`
  width: 25%;
  height: 50vh;
  border: 2px solid ${props => props.theme.text};
  border-top-right-radius: 60px;
  border-bottom-left-radius: 60px;
  padding: 20px;
  margin: 20px 0px;
  ${TabletSize({ width: "60%", height: "fit-content" })};
  &:hover{
    transform: scale(1.1);
    border-top-right-radius: 0px;
    border-bottom-left-radius: 0px;
    border-top-left-radius: 60px;
    border-bottom-right-radius: 60px;
    background-color: ${props => props.theme.text};
    transition: 0.2s;
    ul {
      li{
        color: ${props => props.theme.body};
      }
    }
    &>div{
      color: ${props => props.theme.body};
      border-bottom: 2px solid ${props => props.theme.body};
    }
    svg{
      fill: ${props => props.theme.body};
    }
  }
  &:not(:hover){ transition: 0.2s };
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 15px;
  color: ${props => props.theme.text};
  border-bottom: 2px solid ${props => props.theme.text};
  h3{
    margin-left: 15px;
  }
`;

const SkillList = styled.ul`
  padding: 20px;
  list-style: none;
  cursor: pointer;
  li{
    color: ${props => props.theme.text};
    padding: 10px 5px;
    &:hover{
     transform: scale(1.1);
     transition: 0.25s;
    }
    &:not(:hover){ transition: 0.25s } 
  }
`;

const Icon = styled.img`
  height: 25px;
  width: 25px;
  padding-right: 10px;
`;

const ListBox = styled.div`
  display: flex;
  align-items: center;
`;


export const MySkillPage = () => {

  const theme = useContext(ThemeContext)
  const background = theme.isLight ? ParticlessLightBg : ParticlessDarkBg;
  const iconColor = theme.isLight ? "back" : "white";

  return (
    <Wrapper>
      <Particles 
        params={background} 
        canvasClassName={`${ theme.isLight ? "particlesLight" : "particlesDark" }`}
      />
      <MyLogo/>
      <Text>MY SKILLS</Text>
      <Container>
        <SkillBox>
          <Title>
            <WebDevelopementSkill height={30} width={30} fill={iconColor}/>
            <h3>Web Development</h3>
          </Title>
          <SkillList>
            {WebSkillList.map((item, index) => (
              <li key={index}>
                <ListBox>
                  <Icon src={item.icon} alt={item.title}/>
                  <h4>{item.title}</h4>
                </ListBox>
              </li>  
            ))}
          </SkillList>
        </SkillBox>
        <SkillBox>
          <Title>
            <AppDevelopmentSkill height={30} width={30} fill={iconColor}/>
            <h3>MobileApp Development</h3>
          </Title>
          <SkillList>
            {MobileSkillList.map((item, index) => (
              <li key={index}>
                <ListBox>
                  <Icon src={item.icon} alt={item.title}/>
                  <h4>{item.title}</h4>
                </ListBox>
              </li>  
            ))}
          </SkillList>
        </SkillBox>
        <SkillBox>
          <Title>
            <DesignSkill height={30} width={30} fill={iconColor}/>
            <h3>UX/UI Design</h3>
          </Title>
          <SkillList>
            {DesignSkillList.map((item, index) => (
              <li key={index}>
                <ListBox>
                  <Icon src={item.icon} alt={item.title}/>
                  <h4>{item.title}</h4>
                </ListBox>
              </li>  
            ))}
          </SkillList>
        </SkillBox>
      </Container>
    </Wrapper>
  )
}
